import React, { useEffect, useState } from 'react';
import API from '../services/api_config';

// Admin review of uploaded parent consent forms.
const STATUS = {
  submitted: { label: 'Waiting for review', bg: '#fef3c7', fg: '#92400e' },
  awaiting_form: { label: 'No form yet', bg: '#e5e7eb', fg: '#374151' },
  approved: { label: 'Approved', bg: '#d1fae5', fg: '#065f46' },
  rejected: { label: 'Rejected', bg: '#fee2e2', fg: '#991b1b' },
};

const AdminConsents = () => {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(null);

  const load = () => API.get('/api/v1/admin/consents')
    .then(r => setRows(r.data.consents || []))
    .catch(e => setError(e.response && e.response.status === 403 ? 'This page is for administrators only.' : 'Could not load the list.'));
  useEffect(() => { load(); }, []);

  const view = async (id) => {
    const w = window.open('', '_blank');
    try {
      const r = await API.get('/api/v1/admin/consents/' + id + '/file', { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      if (w) w.location.href = url; else window.location.href = url;
    } catch (e) {
      if (w) w.close();
      alert('Could not open the form.');
    }
  };
  const act = async (id, kind) => {
    let body = {};
    if (kind === 'reject') {
      const note = window.prompt('Reason to send the parent (for example: the form is not signed):', '');
      if (note === null) return;
      body = { note };
    } else if (!window.confirm('Approve this form and open the account?')) return;
    setBusy(id);
    try { await API.post('/api/v1/admin/consents/' + id + '/' + kind, body); await load(); }
    catch (e) { alert((e.response && e.response.data && e.response.data.detail) || 'That did not work.'); }
    finally { setBusy(null); }
  };

  const btn = (bg, fg) => ({ minHeight: '44px', padding: '0 16px', borderRadius: '10px', border: bg === '#fff' ? '1.5px solid #1e3a5f' : 'none', background: bg, color: fg, fontSize: '15px', fontWeight: 700, cursor: 'pointer' });
  const when = (v) => (v ? new Date(v + 'Z').toLocaleString() : '');

  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9', padding: '24px 16px', fontFamily: 'Arial, sans-serif', color: '#1e3a5f' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ fontSize: '26px', margin: '0 0 6px' }}>Parent consent forms</h1>
        <p style={{ fontSize: '15px', color: '#475569', margin: '0 0 20px' }}>Children aged 12 and 13 can sign in only after you approve a signed form. Check that it is signed, names the right child, and that every required box is ticked.</p>
        {error && <p style={{ color: '#991b1b', fontSize: '16px' }}>{error}</p>}
        {rows && rows.length === 0 && <p style={{ fontSize: '16px' }}>No forms yet.</p>}
        {rows && rows.map(r => {
          const s = STATUS[r.status] || STATUS.awaiting_form;
          return (
            <div key={r.id} style={{ background: '#fff', borderRadius: '14px', padding: '18px 20px', marginBottom: '14px', boxShadow: '0 2px 10px rgba(15,23,42,0.06)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
                <div style={{ fontSize: '18px', fontWeight: 700 }}>{r.child_name || r.user_id}</div>
                <span style={{ background: s.bg, color: s.fg, borderRadius: '20px', padding: '5px 12px', fontSize: '14px', fontWeight: 700 }}>{s.label}</span>
              </div>
              <div style={{ fontSize: '15px', lineHeight: 1.6, marginTop: '8px', color: '#334155' }}>
                <div>Child's email: {r.user_id}</div>
                <div>Parent: {r.parent_name} ({r.parent_email})</div>
                {r.parent_typed_name && <div>Name typed on upload: {r.parent_typed_name}</div>}
                <div>Voice allowed: {r.voice_ok ? 'Yes' : 'No'}</div>
                <div>Registered: {when(r.created_at)}{r.submitted_at ? ' \u00B7 Form uploaded: ' + when(r.submitted_at) : ''}</div>
                {r.note && <div>Note: {r.note}</div>}
              </div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '14px' }}>
                {r.file_name && <button type="button" style={btn('#fff', '#1e3a5f')} onClick={() => view(r.id)}>View form</button>}
                {r.file_name && r.status !== 'approved' && <button type="button" disabled={busy === r.id} style={btn('#059669', '#fff')} onClick={() => act(r.id, 'approve')}>Approve</button>}
                {r.status !== 'rejected' && r.status !== 'approved' && r.file_name && <button type="button" disabled={busy === r.id} style={btn('#b91c1c', '#fff')} onClick={() => act(r.id, 'reject')}>Reject</button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminConsents;
